<template>
    <div class="form-textarea" :class="classes" :style="$attrs.style">
        <div v-if="$slots.prepend" class="form-textarea__prepend">
            <slot name="prepend" />
        </div>
        <textarea
            :id="context.name || $attrs.name"
            ref="textarea"
            :value="modelValue"
            :style="inputStyle"
            v-bind="inputAttrs"
            :required="context.required || $attrs.required"
            :name="context.name || $attrs.name"
            class="form-textarea__input"
            @input="$emit('update:modelValue', $event.target.value)"
            @focus="onFocus"
            @blur="onBlur"
            @keyup.enter="onEnterKey"
        />
        <div v-if="$slots.append" class="form-textarea__append">
            <slot name="append" />
        </div>
        <transition name="fade">
            <span v-if="error" class="form-textarea__error">
                {{ error[0] }}
            </span>
        </transition>
    </div>
</template>

<script>
const noop = () => {};
const empty = () => ({});

export default {
    name: 'FormTextarea',
    inject: {
        context: {
            default: empty,
        },
        registerControl: {
            default: () => noop,
        },
    },
    inheritAttrs: false,
    props: {
        modelValue: {},
        error: {
            type: [Object, Array],
            default: null,
        },
        label: String,
        width: {
            type: [String, Number],
            default: '360px',
        },
        inputStyle: {
            type: Object,
            default: () => {},
        },
        type: {
            type: String,
            default: 'text',
        },
        success: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['update:modelValue', 'focus', 'blur', 'enter'],
    data() {
        return {};
    },
    computed: {
        classes() {
            let classes = [];

            if (this.$slots.prepend) {
                classes.push('form-textarea--prepend');
            }

            if (this.$slots.append) {
                classes.push('form-textarea--append');
            }

            if (this.width === '100%') {
                classes.push('form-textarea--fullwidth');
            }

            if (this.error || this.context.error) {
                classes.push('has-error');
            }

            if (this.success) {
                classes.push('success');
            }

            return [...classes, this.$attrs.class];
        },
        inputAttrs() {
            // class/style stay on the wrapper (Vue 2 merged them there)
            const { class: _class, style: _style, ...attrs } = this.$attrs;
            return attrs;
        },
    },

    mounted() {
        this.registerControl(this);
    },

    methods: {
        onFocus() {
            this.$emit('focus');
        },
        onBlur() {
            this.$emit('blur');
        },
        focus() {
            this.$refs.textarea.focus();
        },
        onEnterKey() {
            this.$emit('enter');
        },
    },
};
</script>

<style lang="scss" src="./FormTextarea.scss"></style>
